import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Pill } from '@feathr/components';

interface IMetaConnectedBadgeProps {
  isConnected: boolean;
}

function MetaConnectedBadge({ isConnected }: Readonly<IMetaConnectedBadgeProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Pill
      indicatorVariant={'solid'}
      name={'meta-connected-badge'}
      theme={isConnected ? 'green' : 'yellow'}
      tooltip={
        !isConnected &&
        t('We will finish setting up your Meta integration shortly. Check back in a few minutes.')
      }
      tooltipPosition={'bottom'}
      variant={'secondary'}
    >
      {isConnected ? t('Connected') : t('Configuring')}
    </Pill>
  );
}

export default MetaConnectedBadge;
